var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUiLogoHorizontal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1475.83 126.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lager_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,68.43V2.09h38.31v63.21c0,12.89,5.75,24.2,21.77,24.2h23.51c16.19,0,21.77-11.32,21.77-24.2V2.09h38.31v66.34c0,37.78-22.81,57.63-60.07,57.63h-23.51C22.81,126.07,0,106.22,0,68.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.06,83.75c0,25.07-17.76,42.14-58.68,42.31h-25.94c-48.75,0-56.76-27.16-56.76-43.53h38.48c1.04,6.09,8.36,9.4,20.72,9.4h23.51c13.76,0,19.5-2.79,19.5-7.49,0-3.48-2.96-6.44-11.84-6.44h-42.83c-30.3,0-45.62-13.93-45.62-35.52S179.34.17,222.35,0h24.73c49.28,0,55.37,30.47,55.37,42.31h-38.48c-.7-5.05-5.4-9.4-17.93-9.4h-23.68c-14.45,0-17.76,4-17.76,7.66s2.96,6.44,10.8,6.44h45.79c28.9,0,43.88,15.15,43.88,36.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.39,35.17v12.19h72.26v31.69h-72.26v11.67h84.1v33.26h-122.41V2.09h122.41v33.08h-84.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M615.13,63.03c0,37.61-28.9,60.94-67.04,60.94h-76.79V2.09h76.79c38.13,0,67.04,23.16,67.04,60.94ZM576.12,63.03c0-15.67-11.84-27.51-28.03-27.51h-38.66v55.02h38.66c16.19-.35,28.03-12.01,28.03-27.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M686.56,2.09h38.31v121.89h-38.31V2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M861.12,71.56h39.7c-3.83,32.91-30.3,54.5-66.34,54.5h-23.51c-38.13,0-66.86-25.25-66.86-63.03S771.97,0,810.97,0h23.51c36.04,0,62.51,21.59,66.34,54.5h-39.7c-3.48-10.62-13.41-18.81-26.64-18.81h-23.51c-16.54,0-27.86,11.67-27.86,27.34s11.32,27.86,27.86,27.86h23.51c13.23,0,23.16-8.53,26.64-19.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1072.46,63.03c0,37.78-27.86,63.03-66.86,63.03h-23.51c-38.13,0-66.86-25.25-66.86-63.03S943.08,0,982.09,0h23.51c39,0,66.86,25.42,66.86,63.03ZM1033.45,63.03c0-15.67-11.32-27.34-27.86-27.34h-23.51c-16.54,0-27.86,11.67-27.86,27.34s11.32,27.34,27.86,27.34h23.51c16.54,0,27.86-11.49,27.86-27.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1237,2.09v121.89h-37.61l-70.35-68.08v68.08h-37.61V2.09h37.61l70.35,67.21V2.09h37.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1398.41,83.75c0,25.07-17.76,42.14-58.68,42.31h-25.94c-48.75,0-56.76-27.16-56.76-43.53h38.48c1.04,6.09,8.36,9.4,20.72,9.4h23.51c13.76,0,19.5-2.79,19.5-7.49,0-3.48-2.96-6.44-11.84-6.44h-42.83c-30.3,0-45.62-13.93-45.62-35.52S1272.69.17,1315.7,0h24.73c49.28,0,55.37,30.47,55.37,42.31h-38.48c-.7-5.05-5.4-9.4-17.93-9.4h-23.68c-14.45,0-17.76,4-17.76,7.66s2.96,6.44,10.8,6.44h45.79c28.9,0,43.88,15.15,43.88,36.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1425.21,17.56V7.04h6.07v10.02c0,2.04.91,3.84,3.45,3.84h3.73c2.57,0,3.45-1.79,3.45-3.84V7.04h6.07v10.52c0,5.99-3.62,9.14-9.52,9.14h-3.73c-5.91,0-9.52-3.15-9.52-9.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1451.76,7.04h6.07v19.33h-6.07V7.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1441.52,33.74c-9.04,0-17.56-1.68-23.98-4.74-6.66-3.17-10.33-7.48-10.33-12.13s3.67-8.96,10.33-12.13c6.42-3.06,14.94-4.74,23.98-4.74s17.56,1.68,23.98,4.74c6.66,3.17,10.33,7.48,10.33,12.13s-3.67,8.96-10.33,12.13c-6.42,3.06-14.94,4.74-23.98,4.74ZM1441.52,2.03c-8.75,0-16.95,1.61-23.11,4.55-5.91,2.82-9.17,6.47-9.17,10.29s3.26,7.48,9.17,10.29c6.15,2.93,14.36,4.55,23.11,4.55s16.95-1.61,23.11-4.55c5.91-2.82,9.17-6.47,9.17-10.29s-3.26-7.48-9.17-10.29c-6.15-2.93-14.36-4.55-23.11-4.55Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUiLogoHorizontal);
export default __webpack_public_path__ + "static/media/UI-Logo-Horizontal.384f13072b9ff913d2bf9afc446168a4.svg";
export { ForwardRef as ReactComponent };